import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOintervencoes = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="INTERVENÇÕES DA TERAPIA OCUPACIONAL" />
                    <CheckContainer>
                        <HeaderVerde texto="Intervenções" />
                        <CheckBox texto="Estimulação Sensorial e Cognitiva" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Coordenação Motora" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Treino de Atividades de Vida Diária" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Atividades de Lazer" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Atividades do Brincar" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Brinquedoteca" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Utiliza o Brincar para Minimizar o Sofrimento Durantes as Intervenções Dolorosas com Crianças" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Confecção de Órteses para Prevenção de Deformidades, Contraturas e Lesão por Pressão" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Tecnologias Assistivas" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Intervenção no ambiente" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Avaliação para Dispensação e Treino do Uso de Prótese" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Cuidados Paliativos" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Comunicação Alternativa" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Outras" grupo="tointervecoes" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <div style={{ textAlign: "left" }}>
                            <Select label="O terapeuta ocupacional realiza intervenções mediante solicitação da equipe multiprofissional" nome="tointer" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="O terapeuta ocupacional realiza busca ativa por demandas para a Terapia Ocupacional" nome="tobusca" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="O terapeuta ocupacional tem autonomia para planejar e executar suas intervenções terapêuticas" nome="toautonomia" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="O terapeuta ocupacional dispõe de Recursos Materiais para as intervenções" nome="torecursosinter" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                        </div>
                    </CheckContainer>
                </Caixa>
            )
        }
        return partes
    }
}

export default TOintervencoes